import AppConstants from "../config/app.constants";

let BillableEventsService = function ($http, $q) {

    let getAllEntryTypes = (searchText, limit, offset) => {
        return $http
            .get(AppConstants.api + `/billable-events/get-all-entry-types`, {
                params: {
                    searchText,
                    limit,
                    offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/billable-events/create-billable-events`, data)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, billingCategory, event, branchId) => {
        return $http
            .delete(AppConstants.api + `/billable-events/delete-billable-events`, {
                params: {
                    id,
                    billingCategory,
                    event,
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/billable-events`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/billable-events/${id}/update`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/billable-events/${id}/details`)
            .then((res) => {
                return res.data
            })
    }

    let getBillingCategory = (searchText, limit, offset) => {
        return $http
            .get(AppConstants.api + `/billable-events/get-billing-category`, {
                params: {
                    searchText,
                    limit,
                    offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        getAllEntryTypes,
        create,
        remove,
        all,
        update,
        get,
        getBillingCategory
    }
}

BillableEventsService.$inject = ['$http', '$q']

export default BillableEventsService;


// WEBPACK FOOTER //
// ./client/app/services/billable-events.service.js